<div class="warning-container" fxFlex fxLayout="row" fxLayoutAlign="start start">
  <mat-icon *ngIf="warningData?.icon" class="warning-icon">
    {{warningData?.icon}}
  </mat-icon>
  <img *ngIf="warningData?.image" class="warning-image" [src]="warningData?.image" />
  <div fxFlex fxLayout="column">
    <span *ngIf="warningData?.title" class="warning-title">{{warningData?.title}}</span>
    <span class="warning-message">{{warningData?.message}}</span>
  </div>
</div>